import React from "react";
import path from "path";

interface SNHeaderProps {
  isBackActionVisible: boolean;
  backAction: any;
  logoutAction: any;
  userName: string;
}

function SNHeader({
  isBackActionVisible,
  backAction,
  logoutAction,
  userName,
}: SNHeaderProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  return (
    <div className={"facebook-uploads__header"}>
      {isBackActionVisible && (
        <div
          style={{
            position: "absolute",
            left: 0,
            display: "flex",
            alignItems: "center",
          }}>
          <button
            type={"button"}
            onClick={backAction}
            className={"btn btn-dark facebook-uploads__btn back mx-2"}></button>
          <p className={"text-sm m-0 d-none d-md-block"}>{t.back}</p>
        </div>
      )}
      <p
        className={
          "position-relative w-100 text-sm d-flex flex-column align-items-center my-2"
        }>
        <small>{t.logged_in_as}:</small>
        <span>{userName}</span>
      </p>

      <div
        style={{
          position: "absolute",
          right: 0,
          display: "flex",
          alignItems: "center",
        }}>
        <p className={"text-sm m-0 d-none d-md-block"}>{t.logout}</p>
        <button
          type={"button"}
          onClick={logoutAction}
          className={"btn btn-dark facebook-uploads__btn mx-2"}>
          <img
            src={path.resolve(`${window.basePath}/images/logout.svg`)}
            alt={""}
          />
        </button>
      </div>
    </div>
  );
}

export default SNHeader;
